import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import Button, { ButtonType } from '../../../components/Button';
import { Period } from '../types';

interface IPeriodTabsProps {
  className?: string;
  periods: Period[];
  activePeriod: Period;
  onChange: (period: Period) => void;
}

export default function PeriodTabs({
  className,
  onChange,
  activePeriod,
  periods,
}: IPeriodTabsProps) {
  return (
    <div className={twMerge('flex justify-center items-center space-x-1', className)}>
      {periods.map((p) => (
        <Button
          key={p.value}
          className={clsx({
            'bg-transparent text-secondary': activePeriod?.value !== p.value,
            'bg-btn-primary text-primary': activePeriod?.value === p.value,
          })}
          type={ButtonType.Primary}
          onClick={() => onChange(p)}
        >
          {p.displayVal}
        </Button>
      ))}
    </div>
  );
}
